<template>
  <svg class="bx-badge bx-badge--ai-generated icon icon-ai-generated"
       viewBox="74 63 95 117"
       role="img"
       aria-labelledby="ai-badge-title">
    <title id="ai-badge-title">KI-Hinweis: realistisch wirkendes Bild, das mithilfe künstlicher Intelligenz erzeugt oder wesentlich inhaltlich verändert wurde.</title>
    <use href="#sparkle"
         width="243"
         height="252" />
  </svg>
</template>
